import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { delay, take, of, tap, map } from 'rxjs';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'hazmatsuite-next-multiselect',
  templateUrl: './multiselect.component.html',
  styleUrls: ['./multiselect.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultiselectComponent implements OnInit {
  @Input() required = true;
  @Output() selectionChanged = new EventEmitter<string[]>;

  allItems: string[] = [];
  availableItems: string[] = [];
  selectedItems: string[] = [];
  allowedSizes: number[] = [];
  sizeString = '';

  inputActive = false;
  isValid = false;

  validationTranslations$ = this.languageService.translations$.pipe(map(data => data['ValidationResource']));

  @Input() set items(items: string[]) {
    this.allItems = items;
    this.updateAvailableItems(false);
    this.validate();
  };


  @Input() set groupSizes(sizes: number[]) {
    this.allowedSizes = sizes;
    if (sizes) {
      this.sizeString = this.allowedSizes.join(', ');
      this.validate();
    }
  }

  @Input() set preselectedItems(items: string[]) {
    if (items.length && !items.every((value, index) => value === this.selectedItems[index])) {
      this.selectedItems = items;
      this.validate();
    }
  }

  constructor(private languageService: LanguageService, private cd: ChangeDetectorRef) {
    this.languageService.fetchResources(['ValidationResource']);
  }

  ngOnInit(): void {
    this.validate()
  }

  selectItem(item: string): void {
    this.selectedItems = [...this.selectedItems, item];
    this.validate();
    this.updateAvailableItems(true);
    this.inputActive = false;
  }

  test(): void {
    console.log('BLUR');
  }

  removeItem(item: string): void {
    this.selectedItems = this.selectedItems.filter(i => i !== item);
    this.validate();
    this.updateAvailableItems(true);
    this.inputActive = false;
  }

  unsetFocus(): void {
    of(true).pipe(
      delay(100),
      take(1),
      tap(() => {
        console.log('this.inputActive = false');
        this.inputActive = false;
        this.cd.markForCheck();
      })
    ).subscribe();
  }

  trackByFn(_: number, item: string): string {
    return item;
  }

  trackBySelectedFn(_: number, item: string): string {
    return item;
  }

  private validate(): void {
    this.isValid = (!this.allowedSizes.length && !this.required) || this.allowedSizes.some(size => size === this.selectedItems.length);
  }

  private updateAvailableItems(emit = true): void {
    this.availableItems = this.allItems.filter(item => !this.selectedItems.some(selected => selected === item));
    if (emit) {
      this.selectionChanged.next(this.selectedItems);
    }
  }
}
